import React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { Link } from "gatsby"
// import Fade from "react-reveal/Fade"
import { StaticImage } from "gatsby-plugin-image"

const ClassesPage = () => {
  // const features = [
  //   {
  //     name: "Competitive exchange rates",
  //     description:
  //       "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis suscipit eaque, iste dolor cupiditate blanditiis ratione.",
  //   },
  //   {
  //     name: "No hidden fees",
  //     description:
  //       "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis suscipit eaque, iste dolor cupiditate blanditiis ratione.",
  //   },
  //   {
  //     name: "Transfers are instant",
  //     description:
  //       "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis suscipit eaque, iste dolor cupiditate blanditiis ratione.",
  //   },
  //   {
  //     name: "Mobile notifications",
  //     description:
  //       "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis suscipit eaque, iste dolor cupiditate blanditiis ratione.",
  //   },
  // ]
  return (
    <Layout>
      <Seo title="Classes" />
      <div className="bg-stone-100">
        <section>
          <div className="flex px-8 py-8 shadow-sm md:py-12 md:px-40">
            <p className="font-Roboto text-5xl font-bold lowercase text-bump-gray md:text-7xl">
              Our Courses.
            </p>
          </div>
        </section>

        {
          //Card Section
        }
        <section className="px-6 py-4 md:px-36 md:py-12">
          <div className="mx-auto grid grid-cols-1 gap-10 md:grid-cols-2 ">
            {
              // INTRODUCTION TO BOULDERING CARD
            }

            <div className="flex flex-col rounded-sm border-stone-800 bg-white shadow-md">
              <div>
                <StaticImage
                  src="../images/classes-page/I2B-banner-new.webp"
                  aspectRatio={16 / 9}
                  layout="fullWidth"
                  alt="I2B banner"
                  placeholder="blurred"
                  className="rounded-t-sm"
                />
              </div>

              <div className=" w-full bg-bump-blue px-8 py-6 text-stone-100 md:py-6 md:px-16">
                <p className="font-Roboto text-4xl font-black lowercase leading-none md:text-[3.25rem]">
                  Introduction to Bouldering.
                </p>
              </div>

              <div className="flex flex-1  flex-col px-12 pt-4 pb-8">
                <div className="flex justify-between">
                  <p className="font-OpenSans text-sm leading-loose text-stone-500">
                    Duration: 90 minutes
                  </p>
                </div>

                <p className="flex w-full  pt-4 pb-8 font-OpenSans font-normal normal-case text-stone-700">
                  If you're new to bouldering, this introductory class is
                  perfect for you. Learn what bouldering is all about from our
                  instructors as they guide you through the gym and help you get
                  started on your climbing journey!
                </p>

                <div className="flex flex-1 items-end  justify-end space-x-3">
                  <div>
                    <Link
                      to="/intro-to-bouldering"
                      className=" min-w-[25%] bg-bump-blue px-5 py-3 text-center font-Roboto text-xl font-bold text-stone-100"
                    >
                      More Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {
              // DISCOVER MOVEMENT CARD
            }

            <div className="flex-col rounded-sm border-stone-800 bg-white shadow-md">
              <div>
                <StaticImage
                  src="../images/classes-page/DM-banner.webp"
                  aspectRatio={16 / 9}
                  layout="fullWidth"
                  placeholder="blurred"
                  alt="DM banner"
                  className="rounded-t-sm"
                />
              </div>

              <div className="">
                <div className="w-full bg-bump-wine px-8 py-6 text-stone-100 md:py-6 md:px-16">
                  <p className="font-Roboto text-4xl font-black lowercase leading-none md:text-[3.25rem]">
                    discover movement.
                  </p>
                </div>
                <div className="px-12 pt-4 pb-8">
                  <div className="flex justify-between">
                    <p className="font-OpenSans text-sm leading-loose text-stone-500">
                      Duration: 90 minutes
                    </p>
                  </div>
                  <p className="w-full pt-4 pb-8 font-OpenSans font-normal normal-case text-stone-700">
                    Does being told to just “Try harder!” no longer cut it?
                    We’ve all been there! Discover Movement is a basic course
                    designed to teach an aspiring climber foundational knowledge
                    of climbing. By the end of the course, students will come
                    away with better tools for thinking about and improving
                    their climbing. Don’t just climb harder; climb better.
                  </p>

                  <div className="flex flex-1 items-end  justify-end space-x-3">
                    <div>
                      <Link
                        to="/discover-movement"
                        className=" min-w-[25%] bg-bump-wine px-5 py-3 text-center font-Roboto text-xl font-bold text-stone-100"
                      >
                        More Details
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section
        className="container flex justify-center align-middle h-screen min-w-full bg-fixed bg-center bg-cover classes-banner transition-[height] duration-[99999999ms] ease-in-out"
      >
        <div className="flex flex-col w-full px-12 py-48 md:px-24 md:py-40 z-20">
          
          <Fade duration={3000}>
            <div className="text-5xl flex justify-center text-center md:text-[10rem] text-white font-Roboto font-bold">
              <p className="text-white"> <span className="font-black text-white">Discover</span> Movement.</p>
            </div>
          </Fade>

          
          <div className="text-base md:text-xl max-w-2xl text-white font-thin italic font-OpenSans">
            
          </div>



        </div>

        <div className="absolute z-0 w-full h-full bg-gradient-to-b from-black/30  via-black/10"></div>
      </section>

      <section>
      <div className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <h2 className="text-base text-bump-yellow font-Roboto font-semibold tracking-wide uppercase">Courses</h2>
          <p className="mt-2 text-3xl  font-Roboto font-black  text-gray-900 sm:text-4xl">
            Develop your climbing fundamentals.
          </p>
          <p className="mt-4 max-w-2xl text-lg text-gray-500 lg:mx-auto font-OpenSans">
            If you are new to bouldering, have no fear! This course is designed to teach you all the fundamentals you need to become a proper boulderer.
          </p>
        </div>

        <div className="mt-10">
          <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
            {features.map((feature) => (
              <div key={feature.name} className="relative">
                <dt>
                  <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                  </div>
                  <p className="ml-16 text-lg leading-6 font-medium text-gray-900">{feature.name}</p>
                </dt>
                <dd className="mt-2 ml-16 text-base text-gray-500">{feature.description}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
    </section> */}
      </div>
    </Layout>
  )
}

export default ClassesPage
